import { useFormContext } from 'react-hook-form'
import SelectTagInputWithCheckboxes from '@/components/SelectTagInputWithCheckboxes'
import type { EditPostFormData } from '../types'

interface FormContextsFieldProps {
  items: { id: string; name: string }[]
  loading: boolean
}

export function FormContextsField({ items, loading }: FormContextsFieldProps) {
  const { watch, setValue } = useFormContext<EditPostFormData>()
  const value = watch('contexts') || []
  return (
    <div className="space-y-2">
      <label className="text-sm">Contextos acionais:</label>
      <SelectTagInputWithCheckboxes
        value={value}
        onChange={(v) => setValue('contexts', v, { shouldDirty: true })}
        placeholder="Pesquisar"
        items={items}
        loading={loading}
      />
    </div>
  )
}
